export const FILLOPTIONTYPES: any[] = [
    { Key: 0, Name: 'none', Display: 'i18n:VIEW_STATIC_LIST.FILLOPTION.NONE' },
    { Key: 1, Name: 'linear', Display: 'i18n:VIEW_STATIC_LIST.FILLOPTION.LINEAR' },
    { Key: 2, Name: 'previous', Display: 'i18n:VIEW_STATIC_LIST.FILLOPTION.PREVIOUS' },
    { Key: 3, Name: 'null', Display: 'i18n:VIEW_STATIC_LIST.FILLOPTION.NULL' }
];